import React, { useCallback, useEffect, useRef } from "react";
import { Route, useHistory } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Slide, Stack } from "@mui/material";
import { FileMetadata } from "components";
import { Routes } from "constants/routes";

interface Props {
  open: boolean;
}

export const WorkspaceContentModal: React.FC<Props> = ({ open }) => {
  const history = useHistory();
  const returnLocationRef = useRef<string | null>(null);

  useEffect(() => {
    if (!open) {
      returnLocationRef.current = history.location.pathname + history.location.search;
    }
  }, [open, history.location.pathname, history.location.search]);

  const goBack = useCallback(() => {
    const returnTo = returnLocationRef.current;
    if (returnTo) {
      history.replace(returnTo);
    } else {
      const workspacePath = history.location.pathname.replace(/\/client\/\d+\/workspace\/.*/, "/client/$1/workspace");
      history.replace(workspacePath);
    }
  }, [history]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        goBack();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [goBack]);

  return (
    <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={{ enter: 500, exit: 0 }}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 1300,
          backgroundColor: "#f7f9fc",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Route path={Routes.clientWorkspaceFile}>
          <Stack sx={{ flexDirection: "row", gap: "10px", margin: "16px 16px" }} justifyContent="flex-end">
            <IconButton onClick={goBack}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Route>
        <Route path={Routes.clientWorkspaceFile}>
          <FileMetadata />
        </Route>
      </Box>
    </Slide>
  );
};
